import { useRouter } from 'next/router';
import { Box, Pagination, Table } from '@ads-core/components';
import { vars } from '@ads-core/theme';
import { FilteredCongestionReportsOverviewProps } from 'components/CongestionReportsOverview';
import { baseQueryParams } from 'src/utils';
import { IntegrationApiFeaturesCongestionReportsContractsDataCongestionReport as CongestionReportsData } from '@alliander-fe/api';

import { useAdsContext } from '@ads-core/providers';
import { useRef } from 'react';
import { scrollToElement } from '@ads-core/utils';

import { tableFields, tableFieldsLoading } from './_TableFields';

type OverviewProps = {
  isLoading: boolean;
  pageItems: CongestionReportsData[];
  totalAmount: number;
  amountOfPages: number;
  limit: number;
  currentPage: number;
} & Pick<FilteredCongestionReportsOverviewProps, 'detailWildcardPage' | 'title'>;

export const Overview = ({
  title,
  detailWildcardPage,
  pageItems,
  limit,
  currentPage,
  amountOfPages,
  isLoading,
}: OverviewProps) => {
  const adsContext = useAdsContext();
  const ref = useRef<HTMLDivElement>(null);
  const router = useRouter();
  const queryParams = baseQueryParams;

  const loadingFields = tableFieldsLoading(limit);
  const mappedFields = tableFields(pageItems, detailWildcardPage);

  return (
    <>
      {pageItems?.length || isLoading ? (
        <>
          <Box bg="backgroundLight" borderTopRightRadius="lg" width="100%" padding={10} ref={ref}>
            <Table
              title={title.toString()}
              columns={[
                {
                  dataKey: 'installation',
                  title: 'Installatie',
                  style: { width: 280, padding: 0 },
                },
                {
                  dataKey: 'congestion',
                  title: 'Type Congestie',
                  style: { padding: 0 },
                },
                {
                  dataKey: 'status',
                  title: 'Status',
                  style: { width: 80, padding: 0 },
                },
                { dataKey: 'link', title: '', style: { padding: 0 } },
              ]}
              data={isLoading ? loadingFields : mappedFields}
            />
          </Box>
          {amountOfPages > 1 ? (
            <Box as="footer">
              <Box
                padding={6}
                borderBottomRightRadius="lg"
                borderBottomLeftRadius="lg"
                bg="containerLight"
                style={{ boxShadow: `inset ${vars.boxShadow.primary}` }}
              >
                <Pagination
                  forcePage={currentPage - 1}
                  pageCount={amountOfPages}
                  onPageChange={(e) => {
                    const selectedPage = e.selected + 1;
                    const { path, ...query } = router.query;
                    const pathname = !path || typeof path === 'string' ? path : path.join('/');

                    router.push(
                      {
                        pathname: pathname,
                        query: {
                          ...query,
                          [queryParams.page]: selectedPage,
                        },
                      },
                      undefined,
                      { scroll: false }
                    );

                    scrollToElement(ref, adsContext.headerHeight);
                  }}
                />
              </Box>
            </Box>
          ) : null}
        </>
      ) : null}
    </>
  );
};
